import { ActivityV2 } from '~/components/template/EventTimelineV2/types';

const isDeleted = (task: ActivityV2): boolean =>
  'deleted' in task && task.deleted;

export default isDeleted;
